import {useState} from "react";
import {useQuery} from "react-query";
import axios from "services/axios";

async function getRole(id, filter) {
	const {data} = await axios.get(`/misc/role`, {params: filter});

	return data;
}

export function useRole() {
	const [filter, filterRelations] = useState({
		page: 1,
		search: null,
		limit: 10,
	});
	const [relationId, relationById] = useState(null);
	const fallback = [];
	const {
		data = fallback,
		isLoading,
		isError,
		error,
	} = useQuery(["roles", relationId, filter], async () => getRole(relationId, filter));

	return {data, isLoading, isError, error, filter, filterRelations, relationById};
}
